import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EventNoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"event_note"}/>
}
